<script context="module" lang="ts">
  export type SlideStepsEvent = {
    'click': Step;
    'keypress': Step;
    'inview_enter': Step;
  }
</script>

<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import NavStep, { type Step } from "./NavStep.svelte";
  import BtnControl from "../BtnControl.svelte";
  import Icon, { type IconType } from "../Icon.svelte";
  import { type Readable } from "svelte/store";

  export let steps: Step[];
  export let steps_total: number;
  export let active_step: number;
  export let progress: Readable<number>;

  let steps_el: HTMLElement;
  $: step = steps[active_step];

  const dispatch = createEventDispatcher<SlideStepsEvent>();

  function iconName (index: number): IconType {
    switch (index) {
      case 0: return 'bullet_start';
      case (steps_total - 1): return 'bullet_end';
      default: return 'bullet_step';
    }
  }

</script>

<div class="steps" bind:this={steps_el}>
  {#if step}
    <NavStep step={step} {steps_total} active={true} {progress} />
  {/if}
</div>
<div class="bullets">
  {#each steps as step, index}
    <BtnControl on:click={() => dispatch('click', step)}
      chromeless rounding={0}>
      <Icon name={iconName(index)} />
    </BtnControl>
  {/each}
</div>


<style lang="scss">
 
  .steps {
    display: flex;
    min-height: 136px;

    :global(.step) {
      flex-shrink: 0;
      width: 100%;
      white-space: initial;
    }
  }

  .bullets {
    display: flex;
    justify-content: center;

    :global(button) {
      --width: 32px
    }
  }
</style>